import { Component, computed, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { TemplateDirective } from '../../directives/template.directive';
import { cast } from '../../utils';
import { EnumPickerHandler } from '../smart-input-entity/enum-picker.handler';
import { SmartInputEntity2Component } from 'src/app/components-form/smart-input-entity2/smart-input-entity2.component';

@Component({
  selector: 'app-constant-picker',
  templateUrl: './constant-picker.component.html',
  styleUrl: './constant-picker.component.scss',
  standalone: true,
  imports: [SmartInputEntity2Component, TemplateDirective, TranslateModule],
})
export class ConstantPickerComponent {
  readonly control = input.required<FormControl<string | null>>();
  readonly options = input.required<string[]>();
  readonly allowClear = input<boolean>(false);
  readonly labels = input<{ [option: string]: string }>();
  readonly placeholder = input('');
  readonly resetValue = input<string | null>(null);
  readonly autoSelectSingleChoice = input<boolean>(true);

  readonly enumPickerHandler = computed(
    () =>
      new EnumPickerHandler(
        {
          options: this.options().map((o) => ({ id: o, label: o })),
          allowClear: this.allowClear(),
        },
        this.autoSelectSingleChoice(),
      ),
  );
  readonly cast = cast<string>;
}
